import {Component, HostListener, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {ConfirmationModule} from '../confirmation/confirmation.module';
import {User} from './user.model';
import {UserService} from './user.service';
import {UIRouter} from '@uirouter/angular';
import {CrudConfig, DatatableViewComponent} from '@ngx-ivengi/crud';
import {EnumerationService} from '../enumeration/enumeration.service';
import {AuthenticationService} from '@ngx-ivengi/authentication';

@Component({
  selector: 'app-user-overview',
  templateUrl: './user-overview.component.html'
})
export class UserOverviewComponent extends DatatableViewComponent<User> {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  public authenticatedUserId;
  private firstNameFilterId   = this.crudConfig.getFilterId();
  private lastNameFilterId    = this.crudConfig.getFilterId();
  private emailFilterId       = this.crudConfig.getFilterId();
  private filterTimeout;

  public filters = {
    text: {value: ''},
    userRole: {options: [], value: ''}
  };

  constructor(
    private userService: UserService,
    private router: UIRouter,
    private crudConfig: CrudConfig,
    private modalService: BsModalService,
    private enumerationService: EnumerationService,
    private authenticationService: AuthenticationService
  ) {
    super(userService);

    this.authenticatedUserId = this.authenticationService.getJWTClaims().sub;

    enumerationService.get('user-role').subscribe((roles: any) => {
      this.filters.userRole.options = roles;
    });

    this.requestParams.addSortParam({key: 'lastName', value: 'asc'});
    this.fetchData();
  }

  public filter() {
    if(this.filterTimeout) {
      clearTimeout(this.filterTimeout);
    }

    this.requestParams
      .addFilterParam({
        id: this.firstNameFilterId,
        key: 'firstName',
        operator: 'eq',
        value: this.filters.text.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true'
      })
      .addFilterParam({
        id: this.lastNameFilterId,
        key: 'lastName',
        operator: 'eq',
        value: this.filters.text.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      })
      .addFilterParam({
        id: this.emailFilterId,
        key: 'email',
        operator: 'eq',
        value: this.filters.text.value || '',
        filterFn: 'substringof',
        filterOutcome: 'true',
        joinOperator: 'or'
      });

    this.filterTimeout = setTimeout(() => {
      super.filter(event);
    }, 300);

  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.userService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('user.edit', { id: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user-overview.component.ts